/* tslint:disable */
export var icon = "\n<svg width=\"31\" height=\"31\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M16.5 10h-1v10.043l-3.75-3.793L11 17l5.043 5L21 17l-.75-.75-3.75 3.878z\"/></svg>\n";
//# sourceMappingURL=thin-arrow-down.svg.js.map